import React, {FC, useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {SelectWrapper, InputTextWrapper} from '../../../../../../components/UI/Form/Input'
import {ProfileModel} from '../../../../model'
import {getProfileById} from '../../../../services'
import {useCentral} from '../../../../../../hooks/useCentral'
import {initValues} from '../../../../util/values/profile'
import {useApplication} from '../../../../hooks'
import AditionalForm from '../../../../../../components/UI/Form/aditionalCamp/aditionalCampCentral'
import {TITLE_FORM_PROFILE} from '../../../../util/Constants'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
const Profile: FC = () => {
  const {setValue} = useFormContext()
  const {currentTabItem} = useCentral()
  const {module, getModuleList} = useApplication()

  const getEnterpriseByIdValues = async () => {
    const response = await getProfileById(currentTabItem.idToEdit)
    const data = response.data.data
    type ProfileModelKeys = keyof ProfileModel

    for (const fieldName in initValues) {
      if (initValues.hasOwnProperty(fieldName)) {
        if (data.hasOwnProperty(fieldName)) {
          if (data[fieldName as ProfileModelKeys]) {
            setValue(fieldName, data[fieldName as ProfileModelKeys])
          } else {
            setValue(fieldName, '')
          }
        }
      }
    }
  }
  useEffect(() => {
    getModuleList()
  }, [])

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getEnterpriseByIdValues()
    }
  }, [currentTabItem.idToEdit])

  return (
    <ContentForm isEdit={false} title={TITLE_FORM_PROFILE}>
      <div className='row'>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <SelectWrapper labelText='Módulo' name='aplicacionId' data={module} required />
        </div>
        <div className='col-sm-12 col-md-4 col-xl-3'>
          <InputTextWrapper
            labelText='Perfil'
            name='nombre'
            textPlaceholder='Escribe el perfil'
            type='any'
            required
          />
        </div>
      </div>
      <hr className='divider' />
      <AditionalForm />
    </ContentForm>
  )
}

export default Profile
